<script setup lang="ts">
/**
 * AI arbejder ([D-439], 12-conventions §95): 3 lysegrå, animerede prikker.
 *
 * Den ENESTE måde at vise at en sprogmodel eller billedmodel arbejder på:
 * sidebaren (ud for hovedmenu og undermenu), sidens header
 * (AiActivityIndicator) og knappen der startede kørslen (<AiIcon :busy />).
 * Stilen bor i global.css (.ai-dots), så den er ens overalt.
 *
 * `label` vises som tekst ved siden af prikkerne (fx "Genererer billeder"),
 * `tip` som tooltip (§12.5: v-tip, aldrig title).
 */

defineProps<{
  label?: string;
  tip?: string;
  /** Skjul teksten under md (smal header på mobil); tooltippen bærer den. */
  hideLabelOnMobile?: boolean;
}>();
</script>

<template>
  <span
    class="ai-dots"
    role="status"
    :aria-label="tip || label || 'AI arbejder'"
    v-tip="tip || ''"
    data-ai-dots
  >
    <span class="ai-dot" aria-hidden="true"></span>
    <span class="ai-dot" aria-hidden="true"></span>
    <span class="ai-dot" aria-hidden="true"></span>
    <span v-if="label" class="ml-1.5 text-[11px] text-faint whitespace-nowrap" :class="hideLabelOnMobile ? 'hidden md:inline' : ''">{{ label }}</span>
  </span>
</template>
